<script setup lang="ts">
import { onMounted } from 'vue';
onMounted(() => {
    if (!document.getElementById('gwtScript')) {
        const script = document.createElement('script');
        script.src = '/brightside/brightside/brightside.nocache.js';
        script.id = 'gwtScript';
        document.body.appendChild(script);
    }
});
</script>
<template>
    <div id="gwt" :class="$route.path.startsWith('/gwt/') ? 'active' : ''"></div>
</template>
<style lang="scss">
@layer materialize {
  @import '@/assets/materialize/theme/blue/materialize.blue.scss';
}
</style>
<style>
@import '@/assets/gwt-2.9.0/standard/standard.css';
@import '@/assets/gwt-2.9.0/dark/dark.css';
:root {
  --bs-border-color: #D0E4F6;
	--bs-alt-row-background: var(--p-surface-50);
	--p-form-field-disabled-background: var(--p-surface-100);
}
.bs-dark {
  --bs-border-color: #313a42;
	--bs-alt-row-background: var(--p-surface-800);

  .select2-container {
		.select2-dropdown, .select2-search__field, .input-field input[type=search]:focus {
			background-color: var(--p-form-field-background) !important;
			color: var(--p-form-field-color) !important;
			border: none !important;
		}
		.select2-results__option[aria-selected=true] {
			background-color: var(--p-form-field-filled-background);
		}
		.select2-results__option--highlighted[aria-selected], div.tagsinput span.tag {
			background-color: var(--p-form-field-filled-hover-background);
		}
	}

}
.bs-dark #gwt {
  .modal {
    background-color: var(--p-surface-950) !important;
  }
  .modal .modal-footer {
    background-color: var(--p-surface-900) !important;
  }
  .modal .modal-footer .black-text {
    color: white !important;
  }
  .modal .modal-footer .btn-flat {
    color: white !important;
  }
  .box {
    background-color: var(--p-surface-900);
  }
  .input-field.outlined label.active, .input-field.outlined input:-webkit-autofill+label, .input-field.outlined .select-wrapper+label {
    background-color: var(--p-form-field-background);
	border-radius: var(--p-form-field-border-radius);
  }
  .select-dropdown li.disabled, .select-dropdown li.disabled>span, .select-dropdown li.optgroup {
    color: var(--p-form-field-color);
  }
  .dropdown-content li:hover, .dropdown-content li.active, .dropdown-content li.selected {
    background-color: var(--p-form-field-hover-background);
  }
  .collapsible-body {
    background-color: var(--p-content-background);
  }
  .collapsible-header {
    background-color: var(--bs-border-color);
  }
}

#gwt.active {
  width: 100%;
  height: 100%;
  overflow: auto;
  position: relative;
}

.gwt-DialogBox {
	max-width: 80%;
}
/* Make this show on top of the GWT-Material dialog. */
.gwt-DialogBox, .gwt-PopupPanelGlass {
	z-index: 1003;
}
.gwt-PopupPanelGlass {
    max-width: 100vw;
    max-height: 100vh;
}
.gwt-DialogBox td {
    padding: 0 !important;
    border-radius: 0;
}
.gwt-DialogBox .dialogMiddleCenter {
    padding: 3px !important;
}

#gwt, .gwt-DialogBox {
    font-size: small;
.brightsideContent {
	width: 100%;
	height: 100%;
    display: none;
}
&.active .brightsideContent {
    display: block;
}

/* For buttons in GWT without any classes, use the primevue button styling. */
button:not([class]) {
	padding: var(--p-form-field-sm-padding-y) var(--p-form-field-sm-padding-x);
	background: var(--p-form-field-background);
	border: 1px solid var(--p-form-field-border-color);
	color: var(--p-form-field-color);
	border-radius: var(--p-form-field-border-radius);
	line-height: 1em;
}
button:not([class]):hover {
	background: var(--p-form-field-hover-background);
	border: 1px solid var(--p-form-field-border-color);
	color: var(--p-form-field-color);
	border-radius: var(--p-form-field-border-radius);
	line-height: 1em;
}

fieldset {
  border: 1px solid #c0c0c0;
  padding: 0.35em 0.625em 0.75em;
}

/* Material fixes to comply more closely with the spec. Probably should be moved to SASS at some
 * point and compiled into a custom materialize build.
 */
label {
	color: var(--p-form-field-float-label-color)
}
img {
    display: inline-block;
}
.row .col.input-field {
	min-height: auto;
}
/* Fix help/error text being too far below outlined input fields */
.input-field.outlined .field-error-label {
	margin-top: -4px;
}
.input-field.outlined .field-helper-label {
	margin-top: -6px;
}
.input-field.outlined.listbox-wrapper .field-helper-label {
	margin-top: -13px;
}
.input-field.outlined .character-counter {
	margin-top: -18px;
	margin-right: 14px;
}
.field-helper-label,
.character-counter {
	color: rgb(89, 89, 89);
	font-size: 12px;
}
.switch .field-helper-label {
	display: block;
	margin-top: 8px;
}
.input-field.outlined textarea.materialize-textarea {
	padding: 8px 12px;
}
.input-field.condensed {
	margin-top: 0;
}
.input-field.condensed input {
	margin-bottom: 0;
}
.row.collapse {
    visibility: visible;
}
.row.collapse,
.collapsible-body.compact .row {
	margin-bottom: 0;
}
.collapsible-body.compact {
	padding: 0.5rem;
}
.section h4 {
	font-size: 1.25rem;
}
.gwt-RadioButton + .gwt-TextBox {
	margin-left: 0.5rem;
}
.secondary-content .checkbox,
td > .checkbox,
td > .ibox > .checkbox {
	margin-bottom: 0;
}
.infinite-scroll-panel.row,
.infinite-scroll-panel .collection {
	margin: 0;
}
.collection .collection-item {
	background-color: var(--p-content-background);
}
/* End material fixes */

.sidenav-content > .responsive-img {
	margin-top: 15px;
	cursor: pointer;
}
.brightsideHeader .logo {
	cursor: pointer;
	display: inline-block;
	margin-right: 15px;
}
.brightsideHeader .mainMenu {
	background: none;
    border: none;
    display: inline-block;
}
.brightsideHeader .iconContainer {
	position: absolute;
	top: 0;
	right: 10px;
}
@media screen and (min-width: 1382px) {
	.brightsideHeader .material-icons, .mainMenu.gwt-MenuBar-horizontal .gwt-MenuItem {
		line-height: 80px;
	}
}
.RichTextToolbar {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
}
.panel {
	margin: 10px auto;
}
.pad {
	margin: 10px;
}
table {
width: auto;
}
table.noMat {
    width: auto;
border-collapse: initial;
}
table.noMat:not([cellspacing]) {
border-spacing: 2px;
}
.gwt-MenuBar-horizontal>table {
border-collapse: collapse;
}
.noMat table>thead>tr>th,.noMat table>tfoot>tr>th,.noMat table>tbody>tr>td,.noMat>tbody>tr>td, .noMat>tbody>tr>th, .noMat>thead>tr>th, .gwt-MenuBarPopup td, table.gwt-DatePicker td, table.gwt-DatePicker th, table.btnbox td, .gwt-SuggestBoxPopup td {
padding: 0;
border-radius: 0;
}
.dataGridLastCol {
	padding-right: 15px !important;
}
td[align=right] {
	text-align: right;
}
td[align=center] {
	text-align: center;
}
.mat .com-google-gwt-user-cellview-client-CellTable-Style-cellTableCell {
    height: 43px;
    border-width: 0;
}
.mat .com-google-gwt-user-cellview-client-CellTable-Style-cellTableSelectedRow {
	background-color: #42a5f5;
}
.subRow td:first-child {
    padding-left: 30px !important;
}
.mainRow td:first-child {
    font-weight: bold;
}
.mainRow, .subRow {
    background-color: var(--p-content-background) !important;
}
.mainRow td, .subRow td {
    border-color: #fff !important;
    padding: 2px !important;
}
.bldDates {
    width: 150px !important;
}
.bldDates input {
    width: 90% !important;
    margin-right: 1px;
    margin-top: 10px;
}
.bldButton button{
    margin-left: 14px;
    margin-top: 15px;
    margin-bottom: 5px;
}
.xpad {
	margin-left: 10px;
	margin-right: 10px;
}
.ypad {
	margin-top: 10px;
	margin-bottom: 10px;
}
.rpad {
	margin-right: 10px;
}
.rpadXL {
	margin-right: 50px;
}
.bpad {
	margin-bottom: 10px;
}
.bpadXL {
	margin-bottom: 50px;
}
.mt1 {
	margin-top: 1rem;
}
.mt2 {
    margin-top: 2rem;
}
.no-word-wrap {white-space: nowrap;}
.pre-wrap {white-space: pre-wrap;}
.ar {text-align:right !important;}
.ac,th.ac {text-align:center;}
.al {text-align:left;}
.mauto {margin:auto;}
.red {color:Red;}
.green {color:Green;}
.dataField {
	padding: 0; margin: 0;
	list-style-type: none;
	overflow: auto;
}
.dataField li {
	padding: 0; margin: 0;
	float: left;
}
.dataField li label {
	font-size: x-small;
	display: block;
	color: var(--p-form-field-float-label-color)
}
.boxHeader {
    font-weight: bold;
    font-size: large;
    padding: 0px 5px 5px 5px;
    background-color: var(--bs-border-color);
}
.boxHeader .helpIcon {
	padding: 5px 0;
}
.helpIcon {
	cursor: pointer;
}
.s2header {
    padding: 1px 5px 2px 5px;
    font-weight: bold;
    font-family: Verdana;
    font-size: large;
	background-color: #FFFFFF;
    border-bottom: 1px dotted #E8E8E8;
    color: DarkGreen;
}
.s2content {
    background-color: var(--bs-body-background);
    border: 1px solid #E8E8E8;
}
.reportlabel {
    font-weight: bold;
    color: #999999;
    border-bottom: 1px dotted #CCCCCC;
    margin: 5px 0px 5px 0px;
}
.reportsection {
    margin: 0px 0px 10px 20px;
}
.materialFilterBar {
	height: 64px;
	width: 100%;
	line-height:64px;
	background-color: #FDD835;
	padding: 0 28px;
}
.materialFilterBar .gwt-CheckBox label, .materialFilterBar label {
	color: black;
}
input.noMat[type=checkbox] {
	position: initial;
	visibility: visible;
}
iframe.gwt-RichTextArea {
	border-color: #a9a9a9;
	border-width: 1px;
	background: white;
}
select.noMat {
max-width: 100%;
}
&.release-notes {
	max-width: 800px;
}
&.release-notes ul, ul.noMat, ol.noMat {
    padding: 0 0 0 2em;
}
&.release-notes ul {
	margin-bottom: 1em;
}
&.release-notes ul, &.release-notes ul li, ul.noMat, ul.noMat li {
    list-style-type: disc;
}
&.release-notes ol, &.release-notes ol li, ol.noMat, ol.noMat li {
    list-style-type: decimal;
}
&.release-notes p {
	margin-bottom: 1em;
}
&.release-notes .fusion-builder-row {
    margin-left: 0 !important;
    margin-right: 0 !important;
}
strong {
	font-weight: 600;
}
.release-notes h2 {
    font-size: 2rem;
}
input:not([type]).noMat,
input[type=text].noMat,
input[type=password].noMat, 
input[type=email].noMat,
input[type=url].noMat,
input[type=time].noMat,
input[type=date].noMat,
input[type=datetime-local].noMat,
input[type=tel].noMat,
input[type=number].noMat,
input[type=search].noMat,
textarea.materialize-textarea.noMat,
textarea.noMat,
.input-field textarea.noMat,
select.noMat, .gwt-DatePicker select,
.select-wrapper input.select-dropdown.noMat,
.gwt-TextArea {
	width: auto;
	height: auto;
    line-height: initial;
	border: 1px solid #a9a9a9;
	margin: initial;
	font-size: inherit;
	padding: 2px;
	display: inline-block;
	outline: initial;
	vertical-align: middle;
	-webkit-transition: all 0.30x ease-in-out;
	-moz-transition: all 0.30x ease-in-out;
	-ms-transition: all 0.30x ease-in-out;
	-o-transition: all 0.30x ease-in-out;
	box-sizing: border-box;
	border-radius: 0;
	max-width: 100%;
	background: var(--p-form-field-background);
	color: var(--p-form-field-color);
}
.gwt-TextArea {
	width: 100%;
}
input[type="text"].noMat:disabled,
textarea.noMat:disabled,
select.noMat:disabled,
input[readonly].noMat,
textarea[readonly].noMat,
select[readonly].noMat {
    background-color: var(--p-form-field-disabled-background);
    color: var(--p-form-field-disabled-color);
    border-color: rgba(118, 118, 118, 0.3);
    cursor: default;
}
input[type=text].noMat:focus:not([readonly]),
textarea.noMat:focus:not([readonly]),
select.noMat:focus,
button.noMat:focus {
	box-shadow: 0 0 5px Highlight;
	border: 1px solid Highlight;
}
input:not([type]), input[type=text], input[type=password], input[type=email], input[type=url], input[type=time], input[type=date], input[type=datetime-local], input[type=tel], input[type=number], input[type=search], textarea.materialize-textarea, .dropdown-content {
	background-color: var(--p-form-field-background);
}
input::placeholder {
	color: var(--p-form-field-placeholder-color)
}
.read-only input, .read-only textarea {
	background-color: var(--p-form-field-disabled-background);
	color: var(--p-form-field-disabled-color);
}

.card {
	background-color: var(--bs-body-background);
}

.materialFilterBar label {
color: #000;
font-size: 1em;
}
.materialFilterBar input {
    background: white;
}
.filterBar {
    background-image: url(@/assets/images/filter-bg.gif);
    background-repeat: repeat-x;
    height: 26px;
    line-height: 26px;
    width: 100%;
    color: black;
}
.filterBar label {
	color: black !important;
}
.filterBar table {
    width: auto;
}
.filterBar, .filterBar td {
    padding: 0px 2px;
    font-family: Arial;
    font-size: 10px;
}
.filterBar input, .filterBar input[type="text"], .filterBar input.noMat:focus:not([readonly]), .filterBar select, .filterBar button {
    font-size: 10px;
    border: 1px solid #999999;
    padding: 0;
    background: white;
	color: black;
    height: auto;
    width: auto;
    line-height: 12px;
}
.filterBar .gwt-CheckBox input {
	vertical-align: middle;
}
.gwt-CheckBox.noColor [type="checkbox"].filled-in + label:after {
	border: 2px ridge silver;
    background-color: white;
}
.gwt-CheckBox.noColor [type="checkbox"].filled-in:checked + label:before {
    border-right: 2px solid black;
    border-bottom: 2px solid black;
}
.gwt-CheckBox label {
	color: var(--p-form-field-float-label-color)
}
.collapsible li.active .collapsible-body .input-field label {
	transform: none;
}
.collapsible li.active .collapsible-body .input-field label.active {
	transform: translateY(-130%);
}
.box {
 	border: 5px solid var(--bs-border-color);
	border-radius: 7px;
	background-color: var(--p-surface-0);
}
.ibox {
	display: inline-block;
}
.btnbox {
	margin-top: 5px;
	width: 100%;
}
.btnbox .gwt-Button {
	margin-left: 5px;
	margin-right: 5px;
}
.btnbox .gwt-Image {
	cursor: pointer;
}
.materialButtonBox {
	border-top: 1px solid #E0E0E0;
}
.materialButtonBox .btn {
	margin: 10px 10px 0 10px;
}
.materialButtonBox .gwt-Label.fl {
	line-height: 36px;
    margin: 10px 0 0 10px;
}
.materialButtonBox .col > i {
	margin-top: 13px;
}
.gwt-DecoratorPanel {
	background-color: White;
}
.gwt-Anchor {
	text-decoration: underline;
	cursor: pointer;
}
.saveLabel {
	font-weight: bold;
	line-height: 24px;
	margin-left: 10px;
}
.clickable {
	cursor: pointer;
	cursor: hand;
}
input.small-input, select.small-input, .small-input input, .small-input select {
	width: 5em;
	padding: 2px;
	box-sizing: border-box;
}
.unitPhotoBoxContainer {
	position: relative;
	margin: 0.5em;
	vertical-align: top;
	overflow: hidden;
}
.unitPhotoBoxContainer.hiddenOn::after {
	position: absolute;
	bottom: 0;
	text-decoration: line-through;
    background-color: rgba(255, 255, 255, 0.6);	
}
.unitPhotoBoxContainer.hiddenOn.ota::after {
	content: "OTA";
}
.unitPhotoBoxContainer.hiddenOn.web::after {
    content: "WEB";
}
.unitPhotoBoxContainer.hiddenOn.both::after {
    content: "WEB OTA";
}
.unitPhotoBoxContainer > div {
	border: 1px solid #CCC;
	height: 142px;
}
.unitPhotoBoxContainer.grid {
   display: inline-block;
}
.unitPhotoBoxContainer.grid > div {
   width: 265px;
   height: 177px;
}
.integration-partners .card .card-image {
   padding: 10px 60px 0 60px;
   height: 90px;
   display: flex;
}
.integration-partners .l4 .card .card-image {
   height: 60px;
} 
.integration-partners .card .card-image img {
   margin: auto;
   width: auto;
   max-height: 100%;
}
.brightsideLoading {
	background-image: url(@/assets/images/ajax-loader.gif);
	background-repeat: no-repeat;
	background-position: 50% 20%;
	min-height: 100px;
}
.brightsideLoading * {
	visibility: hidden;
}
.datePager {
	margin: 0 auto;
}
.datePager .gwt-Image {
	cursor: pointer;
	margin: 0 5px;
}
.bold {
	font-weight: bold;
}
.valignTop {
	vertical-align: top !important;
}
.valignMiddle {
	vertical-align: middle;
}
.subdesc {
	color: var(--p-text-muted-color);
	font-weight: normal;
	font-size: small;
}
h5 small.subdesc {
display: block;
line-height: 1.5em;
}
.success-bg {
	background-color: #EFE;
	color: black;
}
.error-bg {
	background-color: #FEE;
	color: black;
}
input.formError,input.formError:focus select.formError,select.formError:focus {
	border: 1px solid red;
	outline-color: red;
	transition: border-color 750ms ease; 
    box-shadow: 0 0 5px red;
}
.displayNone {
	display: none;
}
.datePickerDay,.datePickerWeekdayLabel,.datePickerWeekendLabel {
	font-size:100%;
	padding: 4px 8px;
}
.datePickerDayIsToday {
	padding: 3px 7px;
}
td.datePickerMonth, td.datePickerYear {
	font-size: 100%;
}
.fade-out {
	visibility: hidden;
	opacity: 0;
	-webkit-transition: all 2s ease-in 1s;
	-moz-transition: all 2s ease-in 1s;
	-ms-transition: all 2s ease-in 1s;
	-o-transition: all 2s ease-in 1s;
	transition: all 2s ease-in 1s;
}
.hide-screen {
	display: none;
}
.fl {
	float: left;
}
.fr {
	float: right;
}
.fillWidth {
	width: 100% !important;
	box-sizing: border-box;
}
/*
.greetingText {
	font-size:large;
	text-align:center;
	font-family:cursive;
	padding-top:40px;
	font-weight: bold;
}
.greetingText:empty {
	padding: 0;
	margin: 0;
}
.christmasGreeting {
	height:530px;
	width:100%;
	background-image:url(/RM4/images/wreath.png);
	background-repeat:no-repeat;
	background-position:top center;
	background-size:contain;
	padding-top: 30%;
}
.christmasGreeting .btn {
	background-color: red;
}
.christmasGreeting .greetingText {
	color:red;
}
*/
td.up:before {
	float: left;
	content: "\2191";
	margin-left: 1em;
}
td.down:before {
	float: left;
	content: "\2193";
	margin-left: 1em;
}
td.good {
	color: green;
}
td.bad {
	color: red;
}
.unselectable {
-webkit-touch-callout: none;
-webkit-user-select: none;
-khtml-user-select: none;
-moz-user-select: none;
-ms-user-select: none;
user-select: none;
}

.attention-link {
  animation: color-change 1s infinite;
}

.developerOnly {
	background-color: red;
	color: white;
}
.hcs-CalendarTable {
	border-collapse: collapse;
}
.hcs-CalendarTable td {
	border: 1px solid gray;
	text-align: center;
	vertical-align: middle;
	font-weight: bold;
}
.hcs-CalendarTable td > div {
	width: 40px;
	height: 50px;
	font-weight:bold;
}
.hcs-CalendarTable .gwt-CheckBox label {
	width: 20px;
	padding-left: 0;
}

.colored-list-box .dropdown-content li.active, .colored-list-box .dropdown-content li.selected {
	font-weight: bold;
	filter: brightness(130%);
}
.colored-list-box .dropdown-content li:hover, .colored-list-box .dropdown-content li.active, .colored-list-box .dropdown-content li.selected {
	filter: brightness(130%);
}
.colored-list-box .select-wrapper input.select-dropdown {
	padding-left: 12px;
	box-sizing: border-box;
}
.colored-list-box.noMat .select-wrapper input.select-dropdown {
    height: auto;
    line-height: 1.5;
    margin: 0;
    border-bottom: none;
}
.filterBar .colored-list-box.noMat .select-wrapper input.select-dropdown {
    font-size: 10px;
    border: 1px solid #999;
    padding: 1px 2px;
    line-height: 12px;
}
.noMat.input-field .select-wrapper.gwt-ListBox .caret:before {
	bottom: 4px;
	right: 4px;
}
.listbox-wrapper.noMat {
    display: inline-block;
    margin: 0;
    height: auto;
    padding: 0;
}

@keyframes color-change {
  0% { color: blue; }
  50% { color: darkblue; }
  100% { color: blue; }
}

.gutter-light {
	margin: 10px 20px;
}

.pb-light {
	padding-bottom: 10px;
}

.mt-light {
    margin-top: 10px;
}

/* Fixing autocomplete outlined field type.. */
.autocomplete.outlined input {
	border: 1px solid rgba(0,0,0,0.12) !important;
}
.autocomplete.outlined input[type=text]:focus:not([readonly]) {
	border: 2px solid #42a5f5 !important;
}
.outlined ul.multiValueSuggestBox-list {
	border-bottom: 0 !important;
}

.gwt-Frame {
	width: 100%;
	height: 100%;
	border: none;
}
.loader-wrapper {
	background: rgba(255, 255, 255, 0.701961) !important;
}
}

/* Styles outside the #gwt container, necessary for drag & drop objects. */
.unitPhotoBoxContainer img {
	display: block;
    max-width: 100%;
    width: 100%;
    height: 140px;
}
.unitPhotoBoxContainer img.portrait,
.unitPhotoBoxContainer.grid img.portrait {
    width: auto;
    margin: auto;
}
.unitPhotoBoxContainer.grid img {
	height: 175px;
}
.unitPhotoBoxContainer input[type='text'] {
	width: 100%;
}
.unitPhotoBoxContainer .row .col {
	padding: 0 1.5rem 0 0;
}
.unitPhotoBoxContainer .material-icons {
    width: 32px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.6);
}
.unitPhotoBoxContainer .material-icons.red-text {
	left: 222px;
}
.unitPhotoBoxContainer.grid .material-icons.red-text {
    left: 232px;
}

.fileuploader {
	background-color: var(--p-content-background) !important;
}

.lean-overlay {
    position: fixed;
    z-index:999;
    top: -100px;
    left: 0;
    bottom: 0;
    right: 0;
    height: 125%;
    width: 100%;
    background: #000;
    display: none;

    will-change: opacity;
}
.material-tooltip {
    padding: 10px 8px;
    font-size: 1rem;
    z-index: 2000;
    background-color: transparent;
    border-radius: 2px;
    color: #fff;
    min-height: 36px;
    line-height: 120%;
    opacity: 0;
    display: none;
    position: absolute;
    text-align: center;
    max-width: calc(100% - 4px);
    overflow: hidden;
    left:0;
    top:0;
    will-change: top, left;
}

.backdrop {
  position: absolute;
  opacity: 0;
  display: none;
  height: 7px;
  width: 14px;
  border-radius: 0 0 14px 14px;
  background-color: #323232;
  z-index: -1;
  transform-origin: 50% 10%;

  will-change: transform, opacity;
}
.hiddendiv {
	display: none;
}

/* These are here to make them show on top even if using a gwt-material modal */
.gwt-SuggestBoxPopup, .dateBoxPopup {
	z-index: 1010;
}


</style>